<template>
  <tr class="divide-x divide-slate-200">
    <td class="w-2"></td>
    <td class="p-0">
      <input
        type="number"
        min="1"
        step="1"
        v-model="valueInput"
        class="py-2 pl-4 pr-3 sm:pl-6 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10"
      />
    </td>
    <td class="p-0">
      <input
        type="number"
        v-model="unitAmountInput"
        min="0"
        step="0.01"
        class="input-number-appearance-none relative px-3 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10"
      />
    </td>
    <td class="p-0">
      <input
        type="number"
        v-model="flatAmountInput"
        min="0"
        step="0.01"
        class="input-number-appearance-none relative px-3 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10"
      />
    </td>
    <td class="p-0">
      <select
        v-model="resettablePeriodInput"
        class="relative px-3 py-2 text-sm text-slate-900 text-right w-full focus:outline-none focus:ring-1 focus:ring-slate-900 focus:z-10 appearance-none"
      >
        <option value="lifetime">Lifetime</option>
        <option value="month">Month</option>
        <option value="year">Year</option>
      </select>
    </td>
    <td class="relative py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
      <a
        href="#"
        class="text-blue-600 hover:text-blue-900 focus:outline-none focus:text-blue-800"
        @click="$emit('remove')"
        >Remove</a
      >
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    handle: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    unitAmount: {
      type: Number,
      required: true,
    },
    flatAmount: {
      type: Number,
      required: true,
    },
    resettablePeriod: {
      type: String,
      required: true,
    },
  },
  computed: {
    valueInput: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('update:value', Number.parseInt(value));
      },
    },
    unitAmountInput: {
      get() {
        return this.unitAmount / 100;
      },
      set(value) {
        this.$emit('update:unit-amount', Number.parseInt(value * 100));
      },
    },
    flatAmountInput: {
      get() {
        return this.flatAmount / 100;
      },
      set(value) {
        this.$emit('update:flat-amount', Number.parseInt(value * 100));
      },
    },
    resettablePeriodInput: {
      get() {
        return this.resettablePeriod;
      },
      set(value) {
        this.$emit('update:resettable-period', value);
      },
    },
  },
};
</script>

<style scoped>
.input-number-appearance-none::-webkit-outer-spin-button,
.input-number-appearance-none::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
